import type { ReactNode } from 'react';

export function RecordDetailLayout({
  header,
  main,
  metaRail,
  className,
  /**
   * `'default'` — 1fr / minmax(280px,360px) (sidebar card)
   * `'two-thirds'` — 2fr / 1fr (66% / 34%, full-height rail)
   */
  variant = 'default',
}: {
  header?: ReactNode;
  main: ReactNode;
  metaRail?: ReactNode;
  className?: string;
  variant?: 'default' | 'two-thirds';
}) {
  const gridCols =
    variant === 'two-thirds'
      ? 'lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]'
      : 'lg:grid-cols-[minmax(0,1fr)_minmax(280px,360px)]';

  const railClass =
    variant === 'two-thirds'
      ? 'min-w-0 flex flex-col min-h-0'
      : 'min-w-0';

  return (
    <div className={['min-w-0', className].filter(Boolean).join(' ')}>
      {header != null ? header : null}
      <div className={`grid grid-cols-1 items-start gap-0 ${gridCols}`}>
        <div className="min-w-0">{main}</div>
        {metaRail ? <div className={railClass}>{metaRail}</div> : null}
      </div>
    </div>
  );
}
